<template>
  <div class="ProductGrainWineYeast">
    <div class="content-container">
      <div class="vertical-nav">

        <div
            v-for="(container, index) in availableContainers"
            :key="container"
            class="nav-item"
            :class="{ active: activeIndex === index }"
            @click="scrollToElement(container, index)"
        >
          <div class="nav-circle"></div>
        </div>
      </div>
      <div class="components-wrapper">
        <!-- 电脑端 -->
        <div v-if="!isMobile" class="A" id="A">
          <caidan></caidan>
          <div class="CaiDanBottom"></div>
          <div class="banner-container">
            <img class="img-about" src="@/assets/product/top-img.42c6afdf.jpg">
          </div>
        </div>

        <!-- 手机端 -->
        <div class="A" id="A" v-else>

          <caidan></caidan>


        </div>
        <div class="CaiDanBottom" v-if="isMobile"></div>
        <div class="banner-container" v-if="isMobile">
          <img class="img-about"  src="@/assets/product/top-img.42c6afdf.jpg">
        </div>
<!--          <NFP20C id="NFP20C" v-if="showNFP20C"  :key="'NFP20C'" :animate="showNFP20C"/>-->
<!--          <NFP20A  id="NFP20A" v-if="showNFP20A"  :key="'NFP20A'" :animate="showNFP20A"/>-->
<!--          <NFP20B id="NFP20B" v-if="showNFP20B" :key="'NFP20B'" :animate="showNFP20B"/>-->
        <component
            v-for="item in productComponents"
            :is="item.type"
            :key="`${item.id}-${item.subtype}`"
            :id="item.id"
            :animate="true"
            v-bind="item.subtype ? { subtype: item.subtype } : {}"
        />
<!--        <component-->
<!--            v-for="item in productComponents"-->
<!--            :is="item.type"-->
<!--            :key="item.id + item.subtype" -->
<!--        :id="item.id"-->
<!--        :animate="true"-->
<!--        v-bind="item.subtype ? { subtype: item.subtype } : {}"-->
<!--        />-->

        <div class="B" id="B">
          <div class="page-wrapper"><Bottom></Bottom></div>
        </div>
        </div>


    </div>
  </div>
</template>


<script>

import NFP20C from '@/components/Product/NFP20CComponent.vue'
import NFP20A from '@/components/Product/grainYeast.vue'
import NFP20B from '@/components/Product/NFP20BComponent.vue'
import caidan from "@/components/caidan.vue";
import Bottom from "@/components/bottom.vue";

export default {
  name: 'ProductGrainWineYeast',
  components: {
    Bottom,
    caidan,
    NFP20C,
    NFP20A,
    NFP20B,
  },
  data() {
    return {
      isMobile: false,
      currentType: null,
      activeIndex: 0, // 默认高亮第一个状态点
      showDataItems: [], // 用于控制每个data-item的显示状态
      containerAnimationStates: {
        NFP20C: true,
        NFP20A: true,
        NFP20B: true,
        A:true,
        B:true,
      },
      screenWidth: window.innerWidth
    }
  },
  watch: {
    '$route.params.type': {
      immediate: true,
      handler(newType) {
        this.currentType = newType;
        // 重置激活索引
        this.activeIndex = 0;
        // 重置滚动位置
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      }
    }
  },
  created() {
    console.log('Route params:', this.$route.params)
    console.log('Current route:', this.$route.path)
  },
  computed: {
    // showNFP20C() {
    //   return this.$route.params.type === 'pig' || this.$route.params.type === 'chicken' || this.currentType === 'all'
    // },
    // showNFP20A() {
    //   return this.$route.params.type === 'cattle' || this.currentType === 'all'
    // },
    // showNFP20B() {
    //   return this.$route.params.type === 'cattle' || this.currentType === 'all'
    // },
    // productComponents() {
    //   if (this.currentType === 'all') {
    //     return [
    //       { id: 'NFP50-pig', type: 'NFP50', subtype: 'pig' },
    //       { id: 'NFP50-chicken', type: 'NFP50', subtype: 'chicken' },
    //       { id: 'NFP50-fish', type: 'NFP50', subtype: 'fish' },
    //       { id: 'NFP32', type: 'NFP32' },
    //       { id: 'UXP001', type: 'UXP001' }
    //     ];
    //   }
    //
    //   const result = [];
    //
    //   if (['pig', 'chicken', 'fish'].includes(this.currentType)) {
    //     result.push({
    //       id: `NFP50-${this.currentType}`,
    //       type: 'NFP50',
    //       subtype: this.currentType
    //     });
    //   }
    //
    //   if (this.currentType === 'pig') {
    //     result.push({ id: 'NFP32', type: 'NFP32' });
    //   }
    //
    //   if (this.currentType === 'chicken') {
    //     result.push({ id: 'UXP001', type: 'UXP001' });
    //   }
    //
    //   return result;
    // },
    productComponents() {
      if (this.currentType === 'all') {
        return [
          // { id: 'NFP20C-all', type: 'NFP20C', subtype: 'all' },
          { id: 'NFP20C-pig', type: 'NFP20C', subtype: 'pig' },
          { id: 'NFP20C-chicken', type: 'NFP20C', subtype: 'chicken' },
          { id: 'NFP20A', type: 'NFP20A' },
          { id: 'NFP20B', type: 'NFP20B' },
        ];
      }

      const result = [];
      // if (['pig', 'chicken'].includes(this.currentType)) {
      //   result.push({
      //     id: `NFP20C-${this.currentType}`,
      //     type: 'NFP20C',
      //     subtype: this.currentType
      //   });
      // }
      if (this.currentType === 'pig') {
        result.push({ id: 'NFP20C-pig', type: 'NFP20C', subtype: 'pig' });
      }
      if (this.currentType === 'chicken') {
        result.push({ id: 'NFP20C-chicken', type: 'NFP20C', subtype: 'chicken' });
      }


      if (this.currentType === 'cattle') {
        result.push({ id: 'NFP20A', type: 'NFP20A' });
        result.push({ id: 'NFP20B', type: 'NFP20B' });
      }

      return result;
    },

    availableContainers() {
      const containers = this.productComponents.map(item => item.id);
      containers.unshift('A');
      containers.push('B');
      return containers;
    },
  },
  mounted() {

    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    this.throttledHandleScroll = this.throttle(this.handleScroll, 800);
    this.debouncedUpdateActiveIndex = this.debounce(this.updateActiveIndex, 200);

    window.addEventListener('wheel', this.throttledHandleScroll);
    window.addEventListener('scroll', this.debouncedUpdateActiveIndex);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.updateScale();
  },
  methods:{

    throttle(fn, delay) {
      let last = 0;
      return function(...args) {
        const now = Date.now();
        if (now - last > delay) {
          last = now;
          fn.apply(this, args);
        }
      };
    },

    // 防抖函数，避免过于频繁执行
    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },


    scrollToElement(containerId, index) {
      const element = document.getElementById(containerId);
      if (!element) return;

      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
      });

      this.activeIndex = index;
    },


    // 添加平滑的缓动函数
    easeInOutCubic(t) {
      return t < 0.5
          ? 4 * t * t * t
          : 1 - Math.pow(-2 * t + 2, 3) / 2;
    },

    // 修改滚轮事件处理
    handleScroll(event) {
      // 如果屏幕宽度小于等于 1200px，则不处理滚轮事件（移动设备或小屏）
      if (this.screenWidth <= 1200) return;

      const delta = event.deltaY;  // 获取滚轮垂直方向滚动的距离
      if (delta === 0) return;     // 如果没有实际滚动则返回

      const containers = this.availableContainers;  // 获取当前可用的容器列表
      const currentIndex = this.activeIndex;        // 当前激活容器的索引
      let targetIndex = currentIndex;               // 目标滚动容器的索引，初始为当前索引

      // 如果是向下滚动
      if (delta > 0) {
        if (window.scrollY === 0) {
          // 如果当前在页面顶部，设置目标为第一个容器
          targetIndex = 1;
        } else if (currentIndex < containers.length - 1) {
          // 如果当前不是最后一个容器，滚动到下一个
          targetIndex = currentIndex + 1 ;
        } else {
          // 如果已经是最后一个容器，滚到底部
          this.scrollToBottom();
          return;
        }
      }
      // 如果是向上滚动
      else if (delta < 0) {
        if (currentIndex === 1) {
          // 如果当前是第一个容器，滚动到页面顶部
          this.scrollToTop();
          return;
        } else {
          // 否则滚动到上一个容器
          targetIndex = currentIndex - 1;
        }
      }

      // 滚动到目标容器并更新激活索引
      this.scrollToElement(containers[targetIndex], targetIndex);
    },

    // 添加滚动到顶部的方法
    scrollToTop() {
      const startPosition = window.pageYOffset;
      const duration = 500;
      let startTime = null;

      const animateScroll = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        const easeProgress = this.easeInOutCubic(progress);
        window.scrollTo(0, startPosition * (1 - easeProgress));

        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },

    // 添加滚动到底部的方法
    scrollToBottom() {
      const startPosition = window.pageYOffset;
      const targetPosition = document.documentElement.scrollHeight - window.innerHeight;
      const duration = 500;
      let startTime = null;

      const animateScroll = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        const easeProgress = this.easeInOutCubic(progress);
        window.scrollTo(0, startPosition + (targetPosition - startPosition) * easeProgress);

        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },

    // 修改更新激活索引的方法
    // updateActiveIndex() {
    //   const containers = this.availableContainers;
    //   const viewportCenter = window.scrollY + window.innerHeight / 2;
    //
    //   containers.forEach((id, index) => {
    //     const element = document.getElementById(id);
    //     if (element) {
    //       const elementTop = element.offsetTop;
    //       const elementBottom = elementTop + element.offsetHeight;
    //       const elementCenter = elementTop + element.offsetHeight / 2;
    //
    //       if (Math.abs(viewportCenter - elementCenter) < element.offsetHeight / 2) {
    //         this.activeIndex = index;
    //       }
    //     }
    //   });
    // },
    updateActiveIndex() {
      const containers = this.availableContainers;
      const scrollTop = window.scrollY;
      const offset = 1; // 可选：允许一个小的偏移范围，例如50px内算作进入视口

      containers.forEach((id, index) => {
        const element = document.getElementById(id);
        if (element) {
          const elementTop = element.offsetTop;

          // 如果容器顶部进入视口顶部（或偏移范围内）
          if (elementTop <= scrollTop + offset && elementTop + element.offsetHeight > scrollTop + offset) {
            this.activeIndex = index;
          }
        }
      });
    },


    // 处理窗口大小变化
    handleResize() {
      this.screenWidth = window.innerWidth;
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateActiveIndex);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('wheel', this.handleScroll); // 移除滚轮事件监听器
  }
};
</script>

<style scoped>
.img-about {
  width: 100%;
  display: block;
  height: auto;
  max-width: none;
}
.banner-container {
  width: 100%;
  max-height: 350px;
  overflow: hidden;
  position: relative;
  display: block;
  background-color: white;
}
@media screen and (max-width: 768px) {
  .banner-container {
    height: auto;
  }
}

.A{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 1000;
}
.B{
  width: 100%;

}
.page-wrapper{
  width: 100%;
}
::v-deep .footer-container {
  max-width: none;
  width: 85%;
}
::v-deep .footer-column{
  margin-right: 100px;
}
.vertical-nav {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding: 10px;
  z-index: 1000;
}

.nav-item {
  cursor: pointer;
  padding: 20px 20px 20px 0;
  border-radius: 5px;
  text-align: center;
}

.nav-circle {
  width: 8px;
  height: 8px;
  background: linear-gradient(to bottom, #13a5e4, #40ae45);
  border-radius: 50%;
  margin: 0 auto;
}
/* 鼠标悬停时显示另一张图 */
.nav-circle:hover {
  width: 8px;
  height: 8px;
  background: linear-gradient(to bottom, #13a5e4, #40ae45);
}

/* 当前激活项显示图片 */
.nav-item.active .nav-circle {
  width: 20px;
  height: 20px;
  background-color: transparent;
  background-image: url('@/assets/home/activeDot.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}
@media screen and (max-width: 1200px){
  .vertical-nav{
    display: none;
  }
}

.content-container {
  width: 100%;
  display: flex;
  justify-content: center;
  /*padding: 20px;*/
  box-sizing: border-box;
}

.components-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* 添加 iOS 滚动优化 */
  /* overflow: hidden;*/
}

/* 为每个组件容器添加样式 */
.components-wrapper > div {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  will-change: transform; /* 优化动画性能 */
  transform: translateZ(0); /* 启用硬件加速 */
  backface-visibility: hidden; /* 防止闪烁 */
  /* overflow: hidden;*/
}
@media screen and (max-width: 1050px) and (min-width: 769px) {
  .components-wrapper {
    overflow: hidden;
  }
  /* 为每个组件容器添加样式 */
  .components-wrapper > div {

    overflow: hidden;
  }
}
@media screen  and (max-width: 1700px){
  ::v-deep .footer-container {
    max-width: none;
    width: 90%;
  }
  ::v-deep .footer-column{
    margin-right:calc(5% + 30px );
  }
}
@media screen  and (max-width: 1500px){
  ::v-deep .footer-container {
    max-width: none;
    width: 90%;
  }
  ::v-deep .footer-column{
    margin-right:calc(5% + 10px );
  }
}
@media screen  and (max-width: 1200px){
  ::v-deep .footer-container {
    max-width: none;
    width: 90%;
  }
  ::v-deep .footer-column{
    margin-right:calc(1% + 8px );
  }
}

@media screen and (max-width: 768px) {
  .content-container {
    padding: 10px;
  }

  .components-wrapper {
    gap: 10px;
  }
  ::v-deep .footer-container {
    padding: 0;
  }
}
@media screen and (max-width: 768px) {
  .CaiDanBottom{
    height:100px;
    width: 100%;
  }
  .A{
    position: fixed;
    top:0;
    left: 0;
  }
}


</style>
